export const SET_USER_PROBLEM_DATA = "app/userProblem/SET_USER_PROBLEM_DATA";

export type IUserProblem =
  | { noMic: boolean }
  | { noCam: boolean }
  | { noCamOrMic: boolean }
  | { notAllowed: boolean }
  | { OTError: boolean };
